<template>
<div>
  <ul class="product-list">
    <div class="product-title">产品参数</div>
    <li>
      <div class="product-tip">产品编号</div>
      <div class="product-text">{{goodsCode}}</div>
    </li>
    <li>
      <div class="product-tip">产品名称</div>
      <div class="product-text">{{goodsName}}</div>
    </li>
    <li>
      <div class="product-tip">通用名称</div>
      <div class="product-text">{{commonName}}</div>
    </li>
    <li>
      <div class="product-tip">一级类目</div>
      <div class="product-text">{{firstCategory}}</div>
    </li>
    <li>
      <div class="product-tip">二级类目</div>
      <div class="product-text">{{secondCategory}}</div>
    </li>
    <li>
      <div class="product-tip">规格型号</div>
      <div class="product-text">{{spec}}</div>
    </li>
    <li>
      <div class="product-tip">包装规格</div>
      <div class="product-text">{{packagingSpec}}</div>
    </li>
    <li>
      <div class="product-tip">批准文号</div>
      <div class="product-text">{{approvalNo}}</div>
    </li>
  </ul>
  <div class="product-line"></div>
  <div class="product-detail" id="shopdetail">
    <div class="product-box">
      <div class="product-title">产品介绍</div>
      <div class="product-content" v-html="introduce"></div>
    </div>
    <div class="product-box">
      <div class="product-title">成份与含量</div>
      <div class="product-content" v-html="composition"></div>
    </div>
    <div class="product-box">
      <div class="product-title">产品性状</div>
      <div class="product-content" v-html="shape"></div>
    </div>
    <div class="product-box">
      <div class="product-title">作用与用途</div>
      <div class="product-content" v-html="useu"></div>
    </div>
    <div class="product-box">
      <div class="product-title">用法用量</div>
      <div class="product-content" v-html="dosage"></div>
    </div>
    <div class="product-box">
      <div class="product-title">贮藏与有效期</div>
      <div class="product-content" v-html="storage"></div>
    </div>
    <div class="product-box">
      <div class="product-title">不良反应</div>
      <div class="product-content" v-html="adverse"></div>
    </div>
    <div class="product-box">
      <div class="product-title">注意事项</div>
      <div class="product-content" v-html="matters"></div>
    </div>
    <div class="product-img" id="images">
      <img v-for="item in images" :key="item.itId" :src="item.imgUrl">
    </div>
  </div>
</div>
</template>

<script>
// import { GoodsDesc } from '@/api/resetApi.js'

export default {
  name: 'shopdetails',
  data() {
    return {
      itId: '',
      goodsCode: '',
      goodsName: '',
      commonName: '',
      species_id: '',
      firstCategory: '',
      secondCategory: '',
      spec: '',
      packagingSpec: '',
      approvalNo: '',
      introduce: '',
      composition: '',
      shape: '',
      useu: '',
      dosage: '',
      storage: '',
      adverse: '',
      matters: '',
      images: [],
    }
  },
  created(){
    if(this.$route.query.itId){
      this.itId = this.$route.query.itId
    }
    this.getGoodsDetailDesc()
  },
  methods: {
    async getGoodsDetailDesc() {
      let data = {
        'itId': this.itId
      }
      const res = await GoodsDesc(data)
      console.log(res)
      try {
        if (res.data.code === 200) {
          this.goodsCode = res.data.data.goodsCode
          this.goodsName = res.data.data.goodsName
          this.commonName = res.data.data.commonName
          this.firstCategory = res.data.data.firstCategory
          this.secondCategory = res.data.data.secondCategory
          this.spec = res.data.data.spec
          this.packagingSpec = res.data.data.packagingSpec
          this.approvalNo = res.data.data.approvalNo
          this.introduce = res.data.data.introduce
          this.composition = res.data.data.composition
          this.shape = res.data.data.shape
          this.useu = res.data.data.useu
          this.dosage = res.data.data.dosage
          this.storage = res.data.data.storage
          this.adverse = res.data.data.adverse
          this.matters = res.data.data.matters

          let imagelist = '';
          if (res.data.data.images === null) {
            return
          } else {
            this.images = res.data.data.images
          }
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    }
  }
}
</script>

<style lang="scss" scoped>
.product-list {
  padding: 0.1rem 0 0.1rem 0.1rem;
  li {
    display: flex;
    padding: 0.1rem 0;
    .product-tip {
      flex: 0 0 0.7rem;
      font-size: 0.14rem;
      color: #9B9B9B;
    }
    .product-text {
      flex: 1;
      margin-left: 0.1rem;
      font-size: 0.14rem;
      color: #181818;
    }
  }
}
.product-detail {
  padding: 0.1rem 0 0 0.1rem;
  .product-box {
    margin-bottom: 0.1rem;
    border-bottom: 0.01rem solid #f1f1f1;
    .product-content {
      padding: 0.1rem 0;
      word-wrap:break-word;
      white-space:pre-wrap;
      font-size: 0.12rem;
      color: #181818;
      text-align: left;
      line-height: 0.18rem;
    }
  }
  .product-img {
    padding-right: 0.1rem;
    word-wrap:break-word;
    white-space:pre-wrap;
    font-size: 0.12rem;
    color: #181818;
    img {
      max-width: 100%;
    }
  }
}
.product-line {
  width: 100%;
  height: 0.1rem;
  background: #f1f1f1;
}
.product-title {
  border-left: 0.04rem solid #EA4747;
  padding-left: 0.1rem;
  text-align: left;
  font-size: 0.16rem;
  font-weight:bold;
  color: #181818;
}
</style>